import React, { useState } from 'react'
import { graphql, Link } from 'gatsby'
import { Divide as Hamburger } from 'hamburger-react'
import { PrismicLink } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'

// Components
import Dropdown from './dropdown'
export const query = graphql`
  query ($lang: String) {
    prismicNavigation(lang: { eq: $lang }) {
      ...PrismicHeaderFragment
    }
    prismicConfig {
      ...PrismicCompanyFragment
    }
  }
`

const Header = ({ data }) => {
  const [isOpen, setOpen] = useState(false)
  const navStyles =
    'flex items-center gap-2 py-2 my-2 lg:my-0 px-4 lg:p-4 lg:border-b-2 lg:border-transparent hover:text-white hover:border-indigo-400 hover:text-teal-300 font-semibold text-2xl md:text-lg focus:outline-none focus:ring focus:ring-purple-500 transition duration-300 ease-in-out justify-center'
  const subNavStyles =
    'flex items-center gap-2 py-2 px-4 lg:p-4 lg:border-b-2 lg:border-transparent hover:text-white hover:border-indigo-400 hover:text-teal-300 font-semibold text-xl md:text-lg focus:outline-none focus:ring focus:ring-purple-500 transition duration-300 ease-in-out justify-center md:justify-start'
  const headerData = data.prismicNavigation.data
  const config = data.prismicConfig.data
  return (
    <header role='banner' className='absolute top-0 left-0 right-0 z-20'>
      <nav id='navigation' className='max-w-screen-xl mx-auto relative flex items-center justify-between p-8 xl:px-0 text-white'>
        <Link to='/' className='relative z-20 w-1/2 md:w-1/3 mr-5 focus:outline-none focus:ring focus:ring-purple-500' style={{ maxWidth: 270 }}>
          <GatsbyImage className='h-full object-cover' placeholder='none' loading='eager' image={config.company_logo.gatsbyImageData} alt={config.company_display_name} />
        </Link>
        <span className='lg:hidden z-20'>
          <Hamburger color='white' label='Show menu' rounded easing='ease-in' toggled={isOpen} toggle={setOpen} />
        </span>

        <ul hidden={!isOpen} className={`${!isOpen ? 'hidden' : 'absolute text-center inset-0 bg-gray-800 gap-3 flex flex-col h-screen justify-center z-10'} lg:flex lg:items-center w-full`}>
          {headerData.nav.map((nav, index) => {
            return (
              <React.Fragment key={`nav-${index}`}>
                {nav.items.length > 1 ? (
                  <Dropdown items={nav.items} navStyles={navStyles} subNavStyles={subNavStyles}>
                    {nav.primary.label}
                  </Dropdown>
                ) : (
                  <li className='w-full lg:w-auto' key={`nav-${index}`}>
                    <PrismicLink className={navStyles} field={nav.primary.link} activeClassName='text-indigo-400'>
                      {nav.primary.label}
                    </PrismicLink>
                  </li>
                )}
              </React.Fragment>
            )
          })}
        </ul>
      </nav>
    </header>
  )
}

export default Header
